module.exports = "<tr>\n  <ng-content></ng-content>\n</tr>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/table-header/table-header.component.html
// module id = ../../../../../src/app/shared/components/table-header/table-header.component.html
// module chunks = 12